// AI-CONTEXT: See docs/features/participation-value-dashboard-card.md
import calculateParticipationImpact from './calculateParticipationImpact'
import defaultParticipationParameters from './defaultParticipationParameters'
import { currentParticipationContext } from './birthDatesByPersona'

/**
 * Sums the current societal value (verschil beginsituatie -> huidige situatie)
 * across personas. Recomputed live from each persona's Participation profiles.
 *
 * Only personas whose current situation (t1) has been filled count — an empty
 * current situation reads as "off benefit / not working" and would otherwise
 * show a phantom saving, inflating the total. So unmeasured personas add €0.
 *
 * @param {Array<{Participation?: {t0?: object, t1?: object}}>} personas
 * @param {object} [parameters] - participation model parameters
 * @param {Object<string, string>|null} [birthDates] - PersonaID → geboortedatum (birthDatesByPersona), voor de leeftijdsovergang van 2026.3
 * @returns {number} total societal value in euros
 */
const sumCurrentSocietalValue = (personas, parameters = defaultParticipationParameters, birthDates = null) => {
    if (!Array.isArray(personas)) return 0

    return personas.reduce((total, persona) => {
        const participation = persona?.Participation || {}
        const currentProfile = participation.t1 || {}
        if (!currentProfile.mainActivity) return total

        const { delta } = calculateParticipationImpact({
            participantProfileT0: participation.t0 || {},
            participantProfileT1: currentProfile,
            parameters,
            context: currentParticipationContext(persona, birthDates),
        })
        return total + (Number.isFinite(delta.totalSocietalValue) ? delta.totalSocietalValue : 0)
    }, 0)
}

export default sumCurrentSocietalValue
